module.exports = __webpack_public_path__ + "img/Get-the-app-Popup-th.92ccf34.png";